import { types } from "mobx-state-tree";
import { runInAction, makeAutoObservable } from "mobx";
// helpers
import StoreHelper from "src/base/helpers/store-helper";
import { formatPrice } from "src/base/helpers/price";
// models
// apis
import CommonApi from "src/store/apis/common-api";

class CommonStore {
  constructor() {
    makeAutoObservable(this);
  }

  resetState() {}

  async storeTrackingEvent(payload = null) {
    try {
      let _default = {};

      let reqParams = { ..._default, ...payload };

      return await CommonApi.storeTrackingEvent(reqParams).then((response) => {
        if (response.success != 1) {
          return response.status;
        }

        let data = response.data;

        return data;
      });
    } catch (e) {}
  }
}

export default CommonStore;
